import React, { Component } from 'react';
import { ListLayout } from '../../../Menu/Stock/containers/Layout';
import { Box, TableBody, TableRow, TableCell, Typography } from '@material-ui/core';

class CommercialDashboard extends Component {
    state = {  }
    render() {
        const { commercial } = this.props;
        // console.log('====================================');
        // console.log({commercial});
        // console.log('====================================');
        return (
            <Box>
                 {/* <h2><i className="zmdi zmdi-account m-r-5"></i>Infos</h2> */}
                {/* <Typography variant="h6" >Infos</Typography> */}
                <ListLayout>
                        <TableBody>
                            {commercial.other ? (
                                Object.keys(commercial.other).map( field => (
                                    <TableRow key={field}>
                                        <TableCell>{field}</TableCell>
                                        <TableCell>{ field.startsWith("Photo") ? (
                                                <img src={commercial.other[field]} alt={field} />
                                            ) : (
                                                Array.isArray(commercial.other[field]) ? 
                                                commercial.other[field].join(' - ') :
                                                commercial.other[field]                                                         
                                            )
                                        }
                                        </TableCell>
                                    </TableRow>
                                )) 

                            ) : (
                                <TableRow>
                                    <TableCell colSpan={2}>Pas d'informations</TableCell>
                                </TableRow>
                            ) }
                        </TableBody>
                </ListLayout>
            </Box>
        );
    }
}

export default CommercialDashboard;